import React from 'react';
import './Tag.css';

export default function Tag({ item }) {
  return <span className="Tag">{item}</span>;
}
